import { NgModule } from "@angular/core";
import { RouterModule, PreloadAllModules } from "@angular/router";

import { ResetComponent } from "./modules/reset/reset.component";

import type { Routes } from "@angular/router";

const routes: Routes = [
	{
		path: "home",
		loadChildren: () => import("./modules/home/home.module").then((m) => m.HomeModule),
	},
	{
		path: "checkin",
		loadChildren: () => import("./modules/checkin/checkin.module").then((m) => m.CheckinModule),
	},
	{
		path: "admin",
		loadChildren: () => import("./modules/admin/admin.module").then((m) => m.AdminModule),
	},
	{
		path: "calendar",
		loadChildren: () => import("./modules/calendar/calendar.module").then((m) => m.CalendarModule),
	},
	{
		path: "reset",
		component: ResetComponent,
	},
	{
		path: "",
		redirectTo: "home",
		pathMatch: "full",
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: true,
			preloadingStrategy: PreloadAllModules,
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
